import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import writingIcon from "../../../assets/png/writing.png";
import "./LoadingCreateBook.css";

const LoadingCreateBook = ({ showTimer = true }) => {
  const { t } = useTranslation();
  const [seconds, setSeconds] = useState(0);
  const [showExtraMessage, setShowExtraMessage] = useState(false);

  useEffect(() => {
    if (!showTimer) return;

    const timer = setInterval(() => {
      setSeconds((prevSeconds) => {
        const newSeconds = prevSeconds + 1;

        // Show extra message after 3 minutes (180 seconds)
        if (newSeconds >= 180) {
          setShowExtraMessage(true);
        }

        return newSeconds;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [showTimer]);

  // Format time as MM:SS
  const formatTime = (totalSeconds) => {
    const minutes = Math.floor(totalSeconds / 60);
    const remainingSeconds = totalSeconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
      .toString()
      .padStart(2, "0")}`;
  };

  return (
    <div className="loading-create-book">
      <div className="loading-container">
        {/* Writing Icon */}
        <div className="loading-icon">
          <img src={writingIcon} alt="Writing" className="writing-icon" />
        </div>

        {/* Main Loading Text */}
        {showTimer && (
          <h3 className="loading-title">{t("shaping_your_books_big_idea")}</h3>
        )}

        {!showTimer && (
          <h3 className="loading-no-timer-message">
            {t("this_can_take_5_minutes")}
          </h3>
        )}

        {/* Timer */}
        {showTimer && (
          <div className="loading-timer">{formatTime(seconds)}</div>
        )}

        {/* Extra Message (appears after 3 minutes) */}
        {showTimer && showExtraMessage && (
          <div className="loading-extra-message">
            <p>{t("taking_more_than_usual")}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadingCreateBook;
